var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-actions"},[_vm._t("actionMenu"),_c('div',{staticClass:"listing-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"spacer"}),_vm._t("actionButtons")],2)}
var staticRenderFns = []

export { render, staticRenderFns }